export default "__VITE_ASSET__CqcGKu2n__"